export default __webpack_public_path__ + "static/media/cirrus.0eb2d02c.svg";